define(["exports", "../../AsyncCommand", "axios", "createjs"], function(exports, AsyncCommand, axios){

	function LoadCommand(id, url, vp, dataStorage)
	{
		this._id = id;
		this._url = url;
		this._vp = vp;
		this._dataStorage = dataStorage;
		this.AsyncCommand_constructor();
	}

	var c = LoadCommand;
	createjs.extend(c, AsyncCommand);
	var p = c.prototype;

	p.execute = function(id, url)
	{
        this._id = id || this._id;
        this._url = url || this._url;

		if (!this._url) { this.dispatchComplete(false); return; }

		this._cancelSource = axios.CancelToken.source();
		axios.get(this._url, {
            cancelToken: this._cancelSource.token
		})
            .then(function (responce) {
                _fileloadHandler_.call(this, responce.data);
            }.bind(this))
            .catch(function (error) {
                _errorHandler_.call(this, error);
            }.bind(this));


		this.AsyncCommand_execute.apply(this);
	}

    p.cancel = function()
	{
		if (this._cancelSource)
			this._cancelSource.cancel('Operation canceled by the user.');

		this.AsyncCommand_cancel();
	};

	p.dispatchComplete = function(b)
	{
		if (b) this._handleProgress(1);
		this.AsyncCommand_dispatchComplete.apply(this, [b]);
	}

	p._handleProgress = function(progress)
	{
		this._lastProgress = progress;
	}

	p._add = function(id, result)
	{
		if (this._dataStorage)
			this._dataStorage.addHTML(id, result);
	}

	p._setNotLoaded = function(id)
	{
		if (this._dataStorage)
			this._dataStorage.setHTMLNotLoaded(id);
	}


    function _errorHandler_(errorThrown)
    {	// console.log("err", errorThrown, this.done)
        if (axios.isCancel(errorThrown)) {
            this._canceled = true;
            return;
        }
        if (this.done) return;
        this._setNotLoaded(this._id);
        this.dispatchComplete(false);
    }

    function _fileloadHandler_(data)
    {	// console.log("file", data, this._id, this.done)
        if (this._canceled) return;

        let vp;
        if (this._vp)
        {
            vp = typeof this._vp === "string" ? document.querySelector(this._vp) : this._vp;
            vp.innerHTML = data;
            setTimeout(function () {
                this.dispatchComplete(true);
            }.bind(this), 500);

            return;
        }

        this._add(this._id, data);
        this.dispatchComplete(true);
    }


    createjs.promote(c, "AsyncCommand");

	return c;
});



// WEBPACK FOOTER //
// ./js/rrjs/base/commands/load/axios/AxiosLoadHTMLCommand.js